import React from 'react';

import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { LazySpaceDirectory } from '@confluence/space-directory/entry-points/SpaceDirectory.ts';

export const SpaceDirectoryRoute = () => <LazySpaceDirectory />;

SpaceDirectoryRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: 'spaceDirectoryScreen' },
	},
	MainLayout: {
		navView: PRODUCT_HOME_ID,
		disableMinWidth: true,
	},
});
